import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { TradeDataReports } from "src/model/report"
import { ReportService } from "src/services/api/report"

export const useQueryMyTradeDataReport = (params: Record<string, string | number>) => {
  return useQuery({
    queryKey: [params],
    queryFn: () => ReportService.getTradeDataReport(params),
    initialData: new TradeDataReports(),
    placeholderData: keepPreviousData,
  })
}